// Angular
import { Injectable } from '@angular/core';

// Rxjs
import { Observable } from 'rxjs';

// Services
import { ApiService } from '../api/api.service';

// Models
import { Report, ReportHelper } from '../../models/b2b/reports';
import { User, UserHelper } from '../../models/b2b/user';
import { of, throwError } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';
import { HttpHeaders, HttpParams } from '@angular/common/http';

@Injectable()
export class IncidentsService {
    reportsCallInProgess = false;
    token = localStorage.getItem('tokenOpinions');
    constructor(private api: ApiService) {}

    getReports(id: string, empresa: number): Observable<Report[]> {
        if (this.reportsCallInProgess) {
            return of([]);
        }
        this.reportsCallInProgess = true;
        const url = 'https://soledadopinions.servidorbeta.com/salesforce/';
        let params: HttpParams = new HttpParams();

        const options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/x-www-form-urlencoded',
                Accept: 'application/json',
                'X-Authorization-Token': this.token
            })
        };
        params = params.set('codigo_cliente', id);
        params = params.set('codigo_empresa', empresa);

        return this.api.post(url, params.toString(), options).pipe(
            map((data) => {
                if (data.success === false) {
                    throw new Error(data.message || 'Error obteniendo incidencias');
                }

                const reports: Report[] = data.results.map((x) => ReportHelper.transformFromApi(x));
                return reports;
            }),
            catchError(() => throwError(() => new Error('Error obteniendo incidencias'))),
            finalize(() => {
                this.reportsCallInProgess = false;
            })
        );
    }

    getPromoReports(id: string, empresa: number): Observable<Report[]> {
        return this.getReports(id, empresa).pipe(
            map((data) => {
                const promoReports = data.filter((report) => report.promocion != '');
                // console.log({promoReports});

                return promoReports;
            })
        );
    }

    createReport(data: any, user: User) {
        const defaultAddress = UserHelper.getUserDefaultAddress(user);
        const url = 'https://soledadopinions.servidorbeta.com/salesforce/ticket/add';

        let param: HttpParams = new HttpParams();

        const options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/x-www-form-urlencoded',
                Accept: 'text/plain',
                'X-Authorization-Token': this.token
            })
        };

        let typeIncident = data.typeIncident ?? '';
        typeIncident = typeIncident.toLowerCase() == 'fidelizacion' ? 'Fidelización' : typeIncident;

        param = param.set('incidencia', data.concepto ?? '');
        param = param.set('num_pedido', data.pedido ?? '');
        param = param.set('num_albaran', data.albaran ?? '');
        param = param.set('num_factura', data.factura ?? '');
        param = param.set('num_promocion', data.promocion ?? '');
        param = param.set('tipo', typeIncident);
        param = param.set('contact_name', user.clienteNombre ?? '');
        param = param.set('cod_cliente', user.clienteCodigo ?? '');
        param = param.set('direccion', user.clienteDireccion ?? '');
        param = param.set('email', data.email ?? '');
        param = param.set('AL_CODIGO', user.almacenCodigo ?? '');
        param = param.set('dir_envio', '' + defaultAddress.codigo);
        param = param.set('empresa', '' + user.empresa);

        data.almacen !== '' ? param.set('AL_PEDIDO', data.almacen) : 0;

        // TEST
        // return of(1);
        return this.api.post(url, param.toString(), options);
    }
}
